import { ReduxState } from "../store";

export const selectMultipleChoiceExamStep = (state: ReduxState) => state.exam.multipleChoiceExamStep;
export const selectCodingExamStep = (state: ReduxState) => state.exam.codingExamStep;
export const selectFetchingCodeEditorOutput = (state: ReduxState) => state.exam.fetchingCodeEditorOutput;
export const selectKYC_ID_Photo = (state: ReduxState) => state.exam.KYC_ID_Photo;
export const selectKYC_Personal_Photo = (state: ReduxState) => state.exam.KYC_Personal_Photo;
export const selectKYC_Status = (state: ReduxState) => state.exam.KYC_Status;
export const selectFetchingCodingExam = (state: ReduxState) => state.exam.fetchingCodingExam;
export const selectCodingExamQuestion = (state: ReduxState) => state.exam.codingExamQuestion;
export const selectExamRulesModal = (state: ReduxState) => state.exam.examRulesModal;
export const selectCodeEditorOutput = (state: ReduxState) => state.exam.codeEditorOutput;
export const selectExitExamModal = (state: ReduxState) => state.exam.exitExamModal;
export const selectSelectedExam = (state: ReduxState) => state.exam.selectedExam;
export const selectRecruitingInterviewStep = (state: ReduxState) => state.exam.recruitingInterviewStep;
export const selectCodingExamScreenRecordUploadPercentage = (state: ReduxState) => state.exam.codingExamScreenRecordUploadPercentage;
export const selectCodingExamBreakModal = (state: ReduxState) => state.exam.codingExamBreakModal;
